import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-ble-radio',
  templateUrl: './ble-radio.component.html',
  styleUrls: ['./ble-radio.component.scss']
})
export class BleRadioComponent implements OnInit {

  @Input() valore?: any;
  @Input() testo?: string;
  @Input() block?: boolean;
  @Input() orientation: 'verticale' | 'orizzontale' = 'verticale';
  @Input() list: string[] = [];
  @Input() invalid ? = false;
  @Input() color = 'primary';

  @Output() cambioValore = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  valueChange(evt: any) {
    this.valore = evt;
    this.cambioValore.emit(evt);
  }

}
